var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-footer d-flex justify-content-end",staticStyle:{"margin-left":"0px"}},[_c('strong',{staticClass:"d-flex"},[_vm._v("Todo los derechos reservados © "),_c('div',{staticClass:"mr-2",domProps:{"textContent":_vm._s(_vm.anio)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }